module.exports = __webpack_public_path__ + "img/entrega.698b7f42.svg";